import axios from 'axios'
const reportTypeUrl = '/api/templates/reporttypes'

export default class ReportTypeService {
    // Get Report Types
    static getReportTypes() {
        return new Promise(async (resolve, reject) => {
            try {
                let results = await axios.get(reportTypeUrl)
                resolve(results.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Create Report type
    static createReportType(data) {
        return new Promise(async (resolve, reject) => {
            try {
                let createResult = await axios.post(reportTypeUrl, data)
                resolve(createResult.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Update Report type
    static updateReportType(code, name) {
        return new Promise(async (resolve, reject) => {
            try {
                let updateUrl = `${reportTypeUrl}/${code}`
                let result = await axios.put(updateUrl, {
                    name: name
                })
                resolve(result.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Delete Report type
    static deleteReportType(code) {
        return new Promise(async (resolve, reject) => {
            try {
                let deleteUrl = `${reportTypeUrl}/${code}`
                let result = await axios.delete(deleteUrl)
                resolve(result.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }
}